import type { ReactElement } from 'react';
import { Link, useSearchParams } from 'react-router';
import type { ConversationFilter } from '@chatapp-inbox/shared';
import { FILTER_PARAM, FILTER_TABS } from './filters';
import styles from './ConversationFilterTabs.module.css';

/**
 * As abas são LINKS (não botões): o filtro vive na URL, então dá para copiar, recarregar e voltar.
 * Trocam só o parâmetro "filtro" (o resto da query e a conversa aberta ficam como estão) e usam
 * `replace`: alternar entre abas não deve encher o histórico de "voltar".
 */
export function ConversationFilterTabs({ active }: { active: ConversationFilter }): ReactElement {
  const [searchParams] = useSearchParams();

  return (
    <nav aria-label="Filtrar conversas" className={styles.tabs}>
      {FILTER_TABS.map(({ filter, label }) => {
        const next = new URLSearchParams(searchParams);
        next.set(FILTER_PARAM, filter);
        const isActive = filter === active;
        return (
          <Link
            key={filter}
            to={{ search: `?${next.toString()}` }}
            replace
            aria-current={isActive ? 'true' : undefined}
            className={isActive ? `${styles.tab} ${styles.tabActive}` : styles.tab}
          >
            {label}
          </Link>
        );
      })}
    </nav>
  );
}
